import React, { useEffect, useMemo, useState } from 'react';
import { IndicacionInput } from '../StepProgramaAE/IndicacionInput';
import toast from 'react-hot-toast';

export const StepProgramaDI3 = ({
    setDataSubmissionCallback,
    pantallas,
    idDatosGeneralesRI,
    edit
}) => {
    const [childrenAction, setChildrenAction] = useState(null);
    const [tieneIndicaciones, setTieneIndicaciones] = useState(null);

    const idPantallaRI = useMemo(() => {
        return pantallas.find(p => p.displayName.includes('DI'))?.id
    }, [pantallas]);

    useEffect(() => {
        if (!tieneIndicaciones) {
            setDataSubmissionCallback(() => {
                return toast.error('Agregar al menos una indicación');
            })
        } else {
            setDataSubmissionCallback(null);
        }
    }, [setDataSubmissionCallback, tieneIndicaciones]);

    return (
        <div>
            <div className='step-form-section-container'>
                <label className={`step-form-section-title ${childrenAction ? 'with-children-action' : ''}`}>
                    Indicaciones
                    {Boolean(childrenAction) && childrenAction}
                </label>
                <IndicacionInput
                    idDatosGeneralesRI={idDatosGeneralesRI}
                    idPantallaRI={idPantallaRI}
                    setChildrenAction={setChildrenAction}
                    setTieneIndicaciones={setTieneIndicaciones}
                    edit={edit}
                />
            </div>
        </div>
    )
}